import styled from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 100;

    pointer-events: none;
    background: linear-gradient(0deg, rgba(9, 7, 25, 0.75) 0%, rgba(24, 6, 50, 0) 100%);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const Button = styled.button`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 25px;

    width: 88px;
    height: 40px;

    background: radial-gradient(67.31% 175% at 50% 148.75%, rgba(255, 255, 255, 0.001) 0%, rgba(0, 0, 0, 0) 100%),
        rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);

    border-radius: 40px;
    pointer-events: all;

    border: none;
    color: #fff;
    outline: none;
    cursor: pointer;

    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;
`;
